import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field']
  static classes = ['hide']
  static outlets = ['tom-select']

  hide() {
    this._toggle(true)
  }

  show() {
    if (this.hasTomSelectOutlet) {
      this.tomSelectOutlet.clear()
    }

    this._toggle(false)
  }

  _toggle(shouldHide) {
    this.fieldTargets.forEach(field => {
      field.disabled = shouldHide
      field.classList.toggle(this.hideClass, shouldHide)
    })
  }
}
